var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.25C6.66016 1.25 7.5 2.08945 7.5 3.125V6.875C7.5 7.91016 6.66016 8.75 5.625 8.75H1.875C0.839453 8.75 0 7.91016 0 6.875V3.125C0 2.08945 0.839453 1.25 1.875 1.25H5.625ZM5 3.75H2.5V6.25H5V3.75ZM5.625 11.25C6.66016 11.25 7.5 12.0898 7.5 13.125V16.875C7.5 17.9102 6.66016 18.75 5.625 18.75H1.875C0.839453 18.75 0 17.9102 0 16.875V13.125C0 12.0898 0.839453 11.25 1.875 11.25H5.625ZM5 13.75H2.5V16.25H5V13.75ZM10 3.125C10 2.08945 10.8398 1.25 11.875 1.25H15.625C16.6602 1.25 17.5 2.08945 17.5 3.125V6.875C17.5 7.91016 16.6602 8.75 15.625 8.75H11.875C10.8398 8.75 10 7.91016 10 6.875V3.125ZM12.5 6.25H15V3.75H12.5V6.25ZM13.75 17.5H15V18.75H13.75V17.5ZM17.5 18.75H16.25V17.5H17.5V18.75ZM16.25 11.25H17.5V16.25H13.75V15H12.5V18.75H10V11.25H13.75V12.5H16.25V11.25Z",
    fill: "#3FD645"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.95d1caed24f82806523ba421a2a3c646.svg";
export { ForwardRef as ReactComponent };